export default function Hero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-block px-4 py-2 rounded-full border border-blue-500 bg-white mb-6">
            <span className="text-blue-600 text-sm font-medium whitespace-nowrap">IT Services</span>
          </div>

          <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Comprehensive IT Solutions for Modern Enterprises
          </h1>

          <p className="text-xl text-gray-600 leading-relaxed">
            Empowering your business with cutting-edge technology infrastructure, expert system support, and strategic digital transformation initiatives tailored to your organizational needs.
          </p>
        </div>
      </div>
    </section>
  );
}